import { Box, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomStepper from '../../components/CustomStepper'
import MainText from '../../components/MainText';
import {  AddComment, Business, LocationOn } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { addTab, replaceForm, setFlowField, resetFlow } from '../../tabs/tabsSlice';


export default function CreateOrder() {
  const [supplierName, setSupplierName] = useState('')
  const order = useSelector((state) => state.tabs.forms.orders);
  const orderFlow = useSelector((state) => state.tabs.flows.order);
  const dispatch = useDispatch();

  const setOrder = (updater) => {
    const next = typeof updater === 'function' ? updater(order) : updater;
    dispatch(replaceForm({ formName: 'orders', data: next }));
  };
  const setOrderFlowField = (field, value) => {
    const v = typeof value === 'function' ? value(orderFlow?.[field]) : value;
    dispatch(setFlowField({ name: 'order', field, value: v }));
  };

  useEffect(() => {
    dispatch(addTab({ label: 'Orden de compra', path: '/orders/create-new' }));
  }, [dispatch]);
  return (
    <>
 <Stack 
  sx={{ 
    justifyContent: "space-between", 
    paddingBottom: '5px',
    alignItems: 'center' 
  }} 
  direction={{ xs: 'column', sm: 'row' }} 
  width={'100%'}
  spacing={{ xs: 1, sm: 0 }}
>
  <MainText
    title={'Nueva orden de compra'}
    icon={AddComment}
    width='auto'
  />
  
  <Stack 
    direction={'row'} 
    spacing={2}
    sx={{ 
      fontSize: '0.85rem',
      color: 'text.secondary',
      flexWrap: 'wrap',
      justifyContent: { xs: 'center', sm: 'flex-end' },
      gap: 1.5
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Business sx={{ fontSize: 16, opacity: 0.7 }} />
      <Typography variant='caption' sx={{ fontWeight: 500 }}>
        {supplierName}
      </Typography>
    </Box>
    
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <LocationOn sx={{ fontSize: 16, opacity: 0.7 }} />
      <Typography variant='caption' sx={{ fontWeight: 500 }}>
        {order.storage}
      </Typography>
    </Box>
  </Stack>
</Stack>
      <CustomStepper
        order={order}
        setOrder={setOrder}
        setNameSupplier={setSupplierName}
        flow={orderFlow}
        setFlowField={setOrderFlowField}
        resetFlow={() => dispatch(resetFlow({ name: 'order' }))}
      />
    </>
  )
}
